// src/components/Loading.js
import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <div className="loading-screen">
      <div className="spinner"></div>
      <p> جار التحميل . . . </p>
    </div>
  );
};

export default Loading;